import { TranslateLoader } from "@ngx-translate/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, Observable } from "rxjs";

export class TranslateJsonHttpLoader implements TranslateLoader {

    /**
     * Translation domain
     */
    public constructor(
        private httpClient: HttpClient,
        private prefix = '/assets/i18n',
        private suffix = '.json'
    ) {
    }

    /**
     * Gets the translations from file
     * @param lang
     * @returns {any}
     */
    public getTranslation(lang: string): Observable<Record<string, string>> {
        const headers = new HttpHeaders({
            'Cache-Control':  'private, must-revalidate'
        });
        return this.httpClient
            .get(`${this.prefix}/${lang}${this.suffix}`, { headers: headers, responseType: 'text' })
            .pipe(map((contents: string) => this.parse(contents)));
    }

    /**
     * Parse JSON file
     * @param contents
     */
    public parse(contents: string): Record<string, string> {
        const translations: Record<string, string> = {};

        const json = JSON.parse(contents);

        Object.keys(json).forEach(key => {
          if (json.hasOwnProperty(key)) {
            const translation = json[key];
            if (translation && key.length > 0 && translation.length > 0) {
              translations[key] = translation;
            }
          }
        });

        return translations;
    }

}
